// 从公开脚本 AST 恢复；不是官方仓库原文件。原声明行号见 docs/source-index.json。
let nZ = {
  width: 801,
  height: 154,
};
let n0 = 700;
export { nZ, n0 };
